import { FC } from 'react';

import { CardData } from 'src/models/CardActivities/CardData';
import { SpotlightLayoutType, MediaType, CardTemplate } from 'src/utils/enums';
import SpotlightCardContent, { SpotlightContent } from '../spotlight-card-content/SpotlightCardContent';

interface ChallengeSpotlightProps {
  card: CardData
}

const ChallengeSpotlight: FC<ChallengeSpotlightProps> = ({ card }) => {
  const { templateData, template } = card;
  if (!templateData) return null;

  let nameRow1 = templateData.nameRow1;
  let nameRow2 = templateData.nameRow2;
  let nameRow3 = templateData.nameRow3;
  let mediaUrl = templateData.image;

  if (template === CardTemplate.STEP_BATTLE) {
    nameRow1 = 'The';
    nameRow2 = 'INVITATIONAL';
    nameRow3 = 'Team Step Challenge';
    mediaUrl = '/images/StepBattle_Background.png';
  }

  const content: SpotlightContent = {
    headline: templateData.headline,
    bodyHeader: templateData.bodyHeader,
    body: templateData.body,
    callToAction: templateData.callToAction,
    actionURL: templateData.actionURL,
    mediaUrl: mediaUrl,
    mediaType: MediaType.IMAGE,
    nameRow1,
    nameRow2,
    nameRow3,
  };

  return (
    <div data-testid="challenge-spotlight">
      <SpotlightCardContent content={content} layoutType={SpotlightLayoutType.FULL_SIZE} />
    </div>
  );
};

export default ChallengeSpotlight;
